/**
 * abilityVfxEzreal — Ezreal Q/W/E/R arcane silhouettes (SPY-410).
 */

function mat(THREE, color, opacity = 0.9) {
  return new THREE.MeshBasicMaterial({
    color,
    transparent: opacity < 1,
    opacity,
    side: THREE.DoubleSide
  });
}

export function buildMysticShot(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.55 * (spec.scale || 1);
  const blue = mat(THREE, spec.color || 0x38bdf8);
  const glow = mat(THREE, 0xbae6fd, 0.85);
  const shaft = new THREE.Mesh(
    new THREE.CylinderGeometry(0.05 * s, 0.08 * s, 1.2 * s, 8).rotateX(Math.PI / 2),
    blue
  );
  shaft.position.y = 0.45 * s;
  group.add(shaft);
  const tip = new THREE.Mesh(new THREE.ConeGeometry(0.14 * s, 0.35 * s, 6).rotateX(Math.PI / 2), glow);
  tip.position.set(0, 0.45 * s, 0.7 * s);
  group.add(tip);
  const trail = new THREE.Mesh(new THREE.SphereGeometry(0.12 * s, 8, 8), glow);
  trail.position.set(0, 0.5 * s, -0.5 * s);
  group.add(trail);
  group.userData = { shape: 'mystic_shot' };
  return group;
}

export function buildEssenceFlux(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.65 * (spec.scale || 1.25);
  const gold = mat(THREE, spec.color || 0xfacc15, 0.88);
  const soft = mat(THREE, 0xfef08a, 0.8);
  const core = new THREE.Mesh(new THREE.SphereGeometry(0.28 * s, 10, 10), gold);
  core.position.y = 0.55 * s;
  group.add(core);
  const halo = new THREE.Mesh(new THREE.TorusGeometry(0.4 * s, 0.05 * s, 8, 16), soft);
  halo.rotation.x = Math.PI / 2;
  halo.position.y = 0.55 * s;
  group.add(halo);
  const spark = new THREE.Mesh(new THREE.SphereGeometry(0.1 * s, 8, 8), soft);
  spark.position.set(0.35 * s, 0.9 * s, 0);
  group.add(spark);
  group.userData = { shape: 'essence_flux' };
  return group;
}

export function buildArcaneShift(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.6 * (spec.scale || 1.2);
  const violet = mat(THREE, spec.color || 0xa78bfa, 0.88);
  const mist = mat(THREE, 0xddd6fe, 0.8);
  const ring = new THREE.Mesh(
    new THREE.RingGeometry(0.25 * s, 0.55 * s, 18).rotateX(-Math.PI / 2),
    violet
  );
  ring.position.y = 0.08;
  group.add(ring);
  const swirl = new THREE.Mesh(new THREE.TorusGeometry(0.35 * s, 0.04 * s, 8, 16), mist);
  swirl.rotation.x = Math.PI / 2;
  swirl.position.y = 0.45 * s;
  group.add(swirl);
  const mote = new THREE.Mesh(new THREE.SphereGeometry(0.12 * s, 8, 8), violet);
  mote.position.y = 0.75 * s;
  group.add(mote);
  group.userData = { shape: 'arcane_shift' };
  return group;
}

export function buildTrueshotBarrage(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.85 * (spec.scale || 1.7);
  const deep = mat(THREE, spec.color || 0x0ea5e9);
  const core = mat(THREE, 0x7dd3fc, 0.9);
  const beam = new THREE.Mesh(
    new THREE.CylinderGeometry(0.12 * s, 0.18 * s, 2.2 * s, 10).rotateX(Math.PI / 2),
    deep
  );
  beam.position.y = 0.5 * s;
  group.add(beam);
  const nose = new THREE.Mesh(new THREE.ConeGeometry(0.22 * s, 0.5 * s, 8).rotateX(Math.PI / 2), core);
  nose.position.set(0, 0.5 * s, 1.2 * s);
  group.add(nose);
  const flare = new THREE.Mesh(new THREE.SphereGeometry(0.2 * s, 10, 10), core);
  flare.position.set(0, 0.55 * s, -1.0 * s);
  group.add(flare);
  group.userData = { shape: 'trueshot_barrage' };
  return group;
}
